const React = require("react");
const { useSyncee } = require("../context/SynceeContext");
const { ProductCollectionPage } = require("../components/ProductCollectionPage");
const h = React.createElement;
const DropshippingAllProducts = () => { const { t } = useSyncee(); return h(ProductCollectionPage, { title: t("h_syncee_all_products", "Syncee products"), description: t("h_syncee_all_products_desc", "Synchronize, filter and import products from your Syncee suppliers.") }); };
module.exports = { DropshippingAllProducts };
